<a
  [href]="url"
  [download]="filename"
  (click)="handleClick($event);"
>
  <ng-content></ng-content>
</a>
